import { render } from "./EvmEthInfo.vue?vue&type=template&id=54c95a41"
import script from "./EvmEthInfo.vue?vue&type=script&lang=js"
export * from "./EvmEthInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__